import React from 'react';

import { css } from '@emotion/react';
import { breakpoints, gutterSizes, mediaQuery } from '../../base/theme';

export const TileHeaderWrapper = ({
    children,
    isForSaleMobile,
    ...props
}: React.PropsWithChildren<{
    isForSaleMobile?: boolean;
}>) => {
    const TitleRowStyles = css`
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: ${gutterSizes.base};

        ${mediaQuery.until(breakpoints.small)} {
            ${isForSaleMobile && 'margin-bottom: 0;'}
        }
    `;

    return (
        <div css={TitleRowStyles} {...props}>
            {children}
        </div>
    );
};
